import { React, useState } from 'react';
import { Row, Form, Col, Button } from 'react-bootstrap';
import EyeIcon from '../../../assets/images/eye_icon.svg';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useMutation } from '@apollo/client';
import { CHANGE_PASSWORD } from '../../../gql/auth/mutation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from 'react-bootstrap';

function ChangePassword() {
    const [currpasswordShown, setCurrPasswordShown] = useState(false);
    const [newpasswordShown, setNewPasswordShown] = useState(false);
    const [confpasswordShown, setConfPasswordShown] = useState(false);
    const [passwordUpdated, setPasswordUpdated] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [changePassword, { loading }] = useMutation(CHANGE_PASSWORD, {
        onCompleted(data) {
            setPasswordUpdated(true)
        },
        onError(error){
            if(error.networkError && typeof window !== 'undefined' && !window.navigator.onLine){
                setErrorMessage("Check Your Network, Your Browser Is Offline")
            }
            if (error.message) {
                setErrorMessage(error.message)
            }
            if (!error.message) {
                setErrorMessage("Something Went Wrong !")
            }
        }
    })


    const toggleCurrPassword = () => {
        setCurrPasswordShown(!currpasswordShown);
    };

    const toggleNewPassword = () => {
        setNewPasswordShown(!newpasswordShown);
    };

    const toggleConfPassword = () => {
        setConfPasswordShown(!confpasswordShown);
    };

    const formik = useFormik({
        initialValues: {
            currpwd: "",
            newpwd: "",
            confnewpwd: "",
        },
        validationSchema: Yup.object({
            currpwd: Yup.string()
                .required("Current password is required."),
            newpwd: Yup.string()
                .required("New password is required.")
                .min(8, "Password is too short - should be 8 chars minimum.")
                .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/, "Password must contain one uppercase letter, one lowercase letter, one number and one special character."),
            confnewpwd: Yup.string().required("Confirm password is required.").when("newpwd", {
                is: val => (val && val.length > 0 ? true : false),
                then: Yup.string().oneOf(
                    [Yup.ref("newpwd")],
                    "Both passwords need to be the same."
                )
            })
        }),
        enableReinitialize: true,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            const inputData = {
                oldPassword: values.currpwd,
                newPassword: values.newpwd,
                confirmPassword: values.confnewpwd,
            }
            try {
                const getPasswordUpdated = async () => {
                    const result = await changePassword({
                        variables: {
                            changePasswordInput: inputData
                        }
                    })

                    if(result?.data?.changePassword){
                        resetForm();
                    }
                }

                getPasswordUpdated()
            }
            catch (e) {
                console.error(e)
            }
        }
    })

    if (passwordUpdated) {
        toast.success("Password Updated", {
            position: "bottom-right",
        })

        setPasswordUpdated(false)
    }

    if(errorMessage){
        toast.error(errorMessage, {
            position: "bottom-right",
        })

        setErrorMessage('')
    }

    return (
        <>
            <div className='profile-sec'>
                <h4>Password</h4>
                <p>We recommend that you set a strong password that is at least 8 characters long and includes a mix of letter, number and symbol</p>
                <Form className='profile-form' onSubmit={formik.handleSubmit}>
                    <Row>
                        <Form.Group className="mb-4 pwd-wrapper" as={Col} md="6" controlId="currpwd">
                            <Form.Label>Current Password</Form.Label>
                            <Form.Control
                                name="currpwd"
                                type={currpasswordShown ? "text" : "password"}
                                placeholder=""
                                value={formik.values.currpwd}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={formik.errors.currpwd && formik.touched.currpwd && "error"}
                            />
                            <span className={currpasswordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={toggleCurrPassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                            {formik.errors.currpwd && formik.touched.currpwd && (
                                <div className="input-feedback">{formik.errors.currpwd}</div>
                            )}
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className="mb-4 pwd-wrapper" as={Col} md="6" controlId="newpwd">
                            <Form.Label>New Password</Form.Label>
                            <Form.Control
                                name="newpwd"
                                type={newpasswordShown ? "text" : "password"}
                                placeholder="at least 8 characters"
                                value={formik.values.newpwd}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={formik.errors.newpwd && formik.touched.newpwd && "error"}
                            />
                            <span className={newpasswordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={toggleNewPassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                            {formik.errors.newpwd && formik.touched.newpwd && (
                                <div className="input-feedback">{formik.errors.newpwd}</div>
                            )}
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className="mb-4 pwd-wrapper" as={Col} md="6" controlId="confnewpwd">
                            <Form.Label>Confirm New Password</Form.Label>
                            <Form.Control
                                name="confnewpwd"
                                type={confpasswordShown ? "text" : "password"}
                                placeholder=""
                                value={formik.values.confnewpwd}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={formik.errors.confnewpwd && formik.touched.confnewpwd && "error"}
                            />
                            <span className={confpasswordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={toggleConfPassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                            {formik.errors.confnewpwd && formik.touched.confnewpwd && (
                                <div className="input-feedback">{formik.errors.confnewpwd}</div>
                            )}
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group className="mt-2 mb-5" as={Col} md="6">
                            {
                                loading  ?
                                    <Button className='solid-button'>Change Password
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </Button>
                                    :
                                    <Button className='solid-button' type="submit">Change Password</Button>

                            }
                        </Form.Group>
                    </Row>
                </Form>
            </div>
        </>
    )
}

export default ChangePassword;
